import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-list-card',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="content"><ng-content /></div>
    <rt-icon name="open-in-new" class="hover-affordance" />
  `,
  styleUrl: './list-card.component.less',
})
export class ListCardComponent {}
